import { render } from "./PokemonDetails.vue?vue&type=template&id=10f0dc66&scoped=true"
import script from "./PokemonDetails.vue?vue&type=script&lang=ts"
export * from "./PokemonDetails.vue?vue&type=script&lang=ts"

import "./PokemonDetails.vue?vue&type=style&index=0&id=10f0dc66&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10f0dc66"

export default script